<template>
  <form
    role="form"
    ref="form"
    action="users/stripe"
    class="require-validation"
    data-cc-on-file="false"
    data-stripe-publishable-key="pk_test_51IjJLyKGvXDtl1h222rIda1ncagZeeUdjq4Lcvvby97uqgoMEn5sKzp9upUIlW9AtNDY2pEzcMh9fDHDXW2JL2iW00Bi7018EN"
  >
    <input type="hidden" name="_token" :value="csrf" />
    <!-- <input class='form-control' type='text' name="company_id" value="{{ $company_id }}"
                                hidden> -->
    <input class="form-control" type="text" name="amount" value="200" hidden />
    <input
      class="form-control"
      type="text"
      name="amount"
      id="stripe_token"
      value=""
      hidden
    />
    <!-- <input class='form-control' type='text' name="package_id" value="{{ $package_id }}"
                                hidden> -->
    <div class="form-group row">
      <div class="col-12 required">
        <label class="">Name on Card</label>
        <input class="form-control" type="text" name="card_name" />
      </div>
    </div>

    <div class="form-group row">
      <div class="col-12 required">
        <label class="">Card Number</label>
        <input
          autocomplete="off"
          class="form-control card-number"
          type="text"
          name="card_number"
        />
      </div>
    </div>

    <div class="form-group row">
      <div class="col-12 col-md-4 cvc required">
        <label class="">CVC</label>
        <input
          autocomplete="off"
          class="form-control card-cvc"
          placeholder="ex. 311"
          size="4"
          type="text"
          name="cvc"
        />
      </div>
      <div class="col-12 col-md-4 expiration required">
        <label class="">Expiration Month</label>
        <input
          class="form-control card-expiry-month"
          placeholder="MM"
          size="2"
          type="text"
          name=""
        />
      </div>
      <div class="col-12 col-md-4 expiration required">
        <label class="">Expiration Year</label>
        <input
          class="form-control card-expiry-year"
          placeholder="YYYY"
          size="4"
          type="text"
        />
      </div>
    </div>

    <div class="form-group row">
      <div class="col-md-12 error form-group d-none">
        <div class="alert-danger alert">
          Please correct the errors and try again.
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <!-- <app-load-more
          :preloader="preloader"
          :label="$t('pay_now')"
          type="submit"
          class-name="btn btn-primary btn-block text-center"
          @submit="submit"
        /> -->
        <button
          class="btn btn-primary btn-block mb-3 click_test"
          type="submit"
          @click="functionTwo"
        >
          Pay Now (200)
        </button>
        <!-- <a href="payment-view" class="btn btn-secondary btn-block">Back</a> -->
      </div>
      <p>You can skip the payment for now and proceed to</p>
      <a href="/admin/users/login">&nbsp; login &nbsp;</a> page.
    </div>
  </form>
</template>

<script type="text/javascript" src="https://js.stripe.com/v2/"></script>
<script>
import { FormMixin } from "@/core/mixins/form/FormMixin";
export default {
  mixins: [FormMixin],
  data() {
    return {
      inputs: {
        amount: 200,
        stripeToken: "",
      },
      csrf: document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
      preloader: false,
      c: false,
    };
  },

  methods: {
    beforeSubmit() {
      this.preloader = true;
    },
    submit() {
      this.myFunction();
      let formData = new FormData();

      for (const [key, value] of Object.entries(this.inputs)) {
        formData.append(key, value);
      }
      this.save(formData);
    },
    myFunction() {
      let token;
      var testing_var = false;
      //   
      //   if (this.dropzone_files.length) {
      //     this.dropzone_files.forEach((dropzone_file) =>
      //       formData.append(`dropzone_file[]`, dropzone_file)
      //     );
      //   }
      var $form = $(".require-validation"),
        inputSelector = [
          "input[type=email]",
          "input[type=password]",
          "input[type=text]",
          "input[type=file]",
          "textarea",
        ].join(", "),
        $inputs = $form.find(".required").find(inputSelector),
        $errorMessage = $form.find("div.error"),
        valid = true;
      $errorMessage.addClass("d-none");

      $(".has-error").removeClass("has-error");
      $inputs.each(function (i, el) {
        var $input = $(el);
        if ($input.val() === "") {
          $input.parent().addClass("has-error");
          $errorMessage.removeClass("d-none");
          e.preventDefault();
        }
      });

      if (!$form.data("cc-on-file")) {
        Stripe.setPublishableKey(
          "pk_test_51IjJLyKGvXDtl1h222rIda1ncagZeeUdjq4Lcvvby97uqgoMEn5sKzp9upUIlW9AtNDY2pEzcMh9fDHDXW2JL2iW00Bi7018EN"
        );
        Stripe.createToken(
          {
            number: $(".card-number").val(),
            cvc: $(".card-cvc").val(),
            exp_month: $(".card-expiry-month").val(),
            exp_year: $(".card-expiry-year").val(),
          },
          stripeResponseHandler
        );

        function stripeResponseHandler(status, response) {
          if (response.error) {
            $(".error")
              .removeClass("d-none")
              .find(".alert")
              .text(response.error.message);
          } else {
            /* token contains id, last4, and card type */
            let a = response["id"];
            $("#stripe_token").val(a);
            testing_var = true;
            
            
            // formData.append("stripeToken", token);
          }
        }
      }
    },
    functionTwo() {
      let $form = $(".require-validation");
      $("form.require-validation").bind("submit", function (e) {
        e.preventDefault();
        var $form = $(".require-validation"),
          inputSelector = [
            "input[type=email]",
            "input[type=password]",
            "input[type=text]",
            "input[type=file]",
            "textarea",
          ].join(", "),
          $inputs = $form.find(".required").find(inputSelector),
          $errorMessage = $form.find("div.error"),
          valid = true;
        $errorMessage.addClass("d-none");

        $(".has-error").removeClass("has-error");
        $inputs.each(function (i, el) {
          var $input = $(el);
          if ($input.val() === "") {
            $input.parent().addClass("has-error");
            $errorMessage.removeClass("d-none");
            e.preventDefault();
          }
        });

        if (!$form.data("cc-on-file")) {
          e.preventDefault();
          Stripe.setPublishableKey($form.data("stripe-publishable-key"));
          Stripe.createToken(
            {
              number: $(".card-number").val(),
              cvc: $(".card-cvc").val(),
              exp_month: $(".card-expiry-month").val(),
              exp_year: $(".card-expiry-year").val(),
            },
            stripeResponseHandler
          );
        }
      });

      function stripeResponseHandler(status, response) {
        if (response.error) {
          $(".error")
            .removeClass("d-none")
            .find(".alert")
            .text(response.error.message);
        } else {
          /* token contains id, last4, and card type */
          var token = response["id"];
          $form.find("input[type=text]").empty();
          $form.append(
            "<input type='hidden' name='stripeToken' value='" + token + "'/>"
          );
          $form.get(0).submit(function (e) {
            e.preventDefault();
            data = this.serialize();
          });
        }
        // submit();
      }
      // function submit() {
      //   let formData = new FormData();
      //   for (const [key, value] of Object.entries(this.inputs)) {
      //     formData.append(key, value);
      //   }
      //   this.save(formData);
      // }
    },
    afterSuccess(res) {
      this.preloader = false;
      this.$toastr.s(res.data.message);
    },
    // afterFinalResponse() {
    //   this.preloader = false;
    // },
    afterError(res) {
      this.preloader = false;
      // this.$toastr.e(res.data.message);
    },
  },
  // mounted() {
  //   let $form = $(".require-validation");
  //   $("form.require-validation").bind("submit", function (e) {

  //     var $form = $(".require-validation"),
  //       inputSelector = [
  //         "input[type=email]",
  //         "input[type=password]",
  //         "input[type=text]",
  //         "input[type=file]",
  //         "textarea",
  //       ].join(", "),
  //       $inputs = $form.find(".required").find(inputSelector),
  //       $errorMessage = $form.find("div.error"),
  //       valid = true;
  //     $errorMessage.addClass("d-none");

  //     $(".has-error").removeClass("has-error");
  //     $inputs.each(function (i, el) {
  //       var $input = $(el);
  //       if ($input.val() === "") {
  //         $input.parent().addClass("has-error");
  //         $errorMessage.removeClass("d-none");
  //         e.preventDefault();
  //       }
  //     });

  //     if (!$form.data("cc-on-file")) {
  //       e.preventDefault();
  //       Stripe.setPublishableKey(
  //         "pk_test_51IjJLyKGvXDtl1h222rIda1ncagZeeUdjq4Lcvvby97uqgoMEn5sKzp9upUIlW9AtNDY2pEzcMh9fDHDXW2JL2iW00Bi7018EN"
  //       );
  //       Stripe.createToken({
  //         number: $(".card-number").val(),
  //         cvc: $(".card-cvc").val(),
  //         exp_month: $(".card-expiry-month").val(),
  //         exp_year: $(".card-expiry-year").val(),
  //       });
  //     }
  //   });
  // },
};
</script>
